import React, { useState } from 'react';
import requests from '../utils/requests';

const Autocomplete = ({ value, onClickPrediction = () => {}, onChange = () => { }, width, style, onEnter = () => { }, reference, inputStyle = {} }) => {

    const [predictions, setPredictions] = useState([]);
    const [showingList, showList] = useState(false);

    const handleChange = async e => {
        onChange(e.target.value);
        setPredictions(await requests.getPredictions(e.target.value));
    }

    return <div style={{ marginBottom: 10, width: width || 200, display: "inline-block", ...style }}>
        <input
            onKeyUp={e => {
                if (e.key === "Enter")
                    onEnter(value);
            }}
            autoComplete='off'
            ref={reference}
            placeholder='Search'
            style={{ width: "100%", boxSizing: "border-box", padding: 10, border: "1px solid #ccc", borderRadius: 4, ...inputStyle }}
            value={value} onChange={handleChange} onFocus={e => showList(true)} onBlur={e => setTimeout(() => showList(false), 500)} />
        {showingList && <div style={{ border: "1px outset #ccc", borderRadius: 4, marginTop: 10, marginLeft: 20 }}>
            {predictions.splice(0, 2).map((prediction, i) => <div key={i}
                onClick={() => {
                    onClickPrediction(prediction.description);
                    onChange(prediction.description);
                }}
                style={{
                    display: "flex", justifyContent: "space-between", alignItems: "center",
                    padding: 10, cursor: "pointer", borderBottom: "1px solid #ccc"
                }}>
                <span style={{ fontSize: 14, whiteSpace: "nowrap", display: 'inline-block', overflow: "hidden", marginRight: 10 }}>{prediction.description}</span>
            </div>)}
        </div>}
    </div>;

}
export default Autocomplete;